import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../../FaIcon';
import { Switch } from '../../buttons/Swtich';

/**
 * Tarjeta compacta de un módulo del portal del cliente.
 *
 * - master `Switch` que habilita/deshabilita la capacidad por defecto del portal.
 * - resumen (cuando está habilitado y hay dato, ej. "3 plantillas"); sino la descripción.
 * - cuando el módulo tiene config agencia-side (Tablero / Vistas) es expandible: el contenido
 *   se muestra en un panel full-width debajo de la grilla (lo maneja PortalModulesGrid).
 * - estado `locked` (ej. MCP sin plan de la agencia) → CTA de upgrade en vez del switch.
 */
export function PortalModuleCard({
    icon, name, description, summary, warning,
    enabled, onToggleEnabled, toggleDisabled, toggleHint,
    expandable, active, onToggleExpand,
    locked, lockedCta,
}) {
    const { t } = useTranslation();
    const subtitle = (enabled && summary) ? summary : description;

    return (
        <div className={`pm-card ${enabled ? '-enabled' : ''} ${active ? '-active' : ''} ${locked ? '-locked' : ''} ${expandable ? '-expandable' : ''} ${warning ? '-warn' : ''}`}>
            <div
                className="pm-card-head"
                onClick={expandable ? onToggleExpand : undefined}
                role={expandable ? 'button' : undefined}
            >
                <span className="pm-card-icon"><FaIcon iconName={icon} /></span>
                <div className="pm-card-titles">
                    <span className="pm-card-name">{name}</span>
                    <span className="pm-card-sub">{subtitle}</span>
                </div>
            </div>

            {warning && (
                <div className="pm-card-warn">
                    <FaIcon iconName="triangle-exclamation" />
                    <span>{warning}</span>
                </div>
            )}

            <div className="pm-card-footer">
                {locked ? (
                    <Link to={lockedCta.to} target="_blank" className="pm-card-lock-cta">
                        <FaIcon iconName="lock" />
                        <span>{lockedCta.label}</span>
                    </Link>
                ) : (
                    <span
                        className={`pm-card-switch-wrap ${toggleDisabled ? '-disabled' : ''}`}
                        title={toggleDisabled ? toggleHint : undefined}
                    >
                        <Switch
                            name={`module_${icon}`}
                            checked={!!enabled}
                            onChange={(e) => !toggleDisabled && onToggleEnabled(e.target.checked)}
                            style={{ margin: 0 }}
                        />
                        <span className="pm-card-switch-label">
                            {enabled ? t('portal_modules.toggle_on') : t('portal_modules.toggle_off')}
                        </span>
                    </span>
                )}

                {expandable && (
                    <button type="button" className={`pm-card-expand-btn ${active ? '-open' : ''}`} onClick={onToggleExpand}>
                        {active ? t('portal_modules.collapse') : t('portal_modules.configure')}
                        <FaIcon iconName="chevron-down" />
                    </button>
                )}
            </div>
        </div>
    );
}
